import React from 'react';
import Modal from 'material-ui/Modal';
import ContactSupportButton from '../../atoms/ContactSupportButton';
import Icon from '../../molecules/Icon';

class ContactSupportModal extends React.Component {
  constructor() {
    super();
    this.state = {
      open: false,
    };
    this.handleOpen = this.handleOpen.bind(this);
    this.handleClose = this.handleClose.bind(this);
  }

  handleOpen() {
    this.setState({ open: true });
  }

  handleClose() {
    this.setState({ open: false });
  }

  render() {
    return (
      <div>
        <ContactSupportButton onClick={this.handleOpen} />
        <Modal
          aria-labelledby="simple-modal-title"
          aria-describedby="simple-modal-description"
          open={this.state.open}
          onClose={this.handleClose}
        >
          <div className="modal">
            <div className="modal--banner">
              <button onClick={this.handleClose}>
                <Icon icon="close" imgStyle="modal--icon" />
              </button>
              <h2 className="m__0 font-color__white p__30">Contact Support</h2>
            </div>
            <div className="modal--text--container">
              <p className="modal--text font-body">Let us know how we can help.</p>
              <p className="modal--text font-body">
              You can contact customer support by phone using the contact details below.
              </p>
              <p className="modal--text heading-4 text-align__center">
                <strong>
                  <a className="modal--link" href="tel:01738 646666">01738 646666</a>
                </strong>
              </p>
            </div>
          </div>
        </Modal>
      </div>
    );
  }
}

export default ContactSupportModal;



// WEBPACK FOOTER //
// src/components/molecules/ContactSupportModal/index.jsx